import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { attachmentApi } from './attachment.api';
import { normalizeAttachment } from '../model/attachment.lib';

export const ATTACHMENTS_QUERY_KEY = ['attachments'];

// Формат конверта GET /api/attachments в спеке не зафиксирован —
// принимаем массив как есть либо обёртки { attachments } / { data }
const extractAttachments = (response) => {
	const payload = response?.data;
	if (Array.isArray(payload)) return payload;
	return payload?.attachments || payload?.data || [];
};

/**
 * Список ранее загруженных вложений текущего пользователя
 * (база для выбора «Мои файлы» в модалке прикрепления).
 */
export const useAttachments = (options = {}) =>
	useQuery({
		queryKey: ATTACHMENTS_QUERY_KEY,
		queryFn: () => attachmentApi.fetchAll(),
		select: (response) => extractAttachments(response).map(normalizeAttachment),
		...options,
	});

/** Удаление вложения из «Моих файлов» с обновлением списка. */
export const useDeleteAttachment = (options = {}) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id) => attachmentApi.remove(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ATTACHMENTS_QUERY_KEY });
		},
		...options,
	});
};
